declare global {
  interface Map<K, V> {
    getOrInsertComputed(key: K, callback: (key: K) => V): V;
  }
}

// Polyfill for Map.prototype.getOrInsertComputed (required by pdfjs-dist 5.x on unsupported browsers like Safari)
if (typeof Map !== 'undefined' && !Map.prototype.getOrInsertComputed) {
  Object.defineProperty(Map.prototype, 'getOrInsertComputed', {
    value: function <K, V>(
      this: Map<K, V>,
      key: K,
      callback: (key: K) => V
    ): V {
      if (this.has(key)) {
        return this.get(key) as V;
      }
      const value = callback(key);
      this.set(key, value);
      return value;
    },
    writable: true,
    configurable: true,
    enumerable: false,
  });
}

// Polyfill for crypto.randomUUID in non-secure contexts (e.g. LAN HTTP testing http://192.168.x.x:5173)
function generateFallbackUUID(): `${string}-${string}-${string}-${string}-${string}` {
  const bytes = new Uint8Array(16);
  const cryptoObj = typeof crypto !== 'undefined' ? crypto : (typeof globalThis !== 'undefined' ? globalThis.crypto : undefined);

  if (cryptoObj && typeof cryptoObj.getRandomValues === 'function') {
    cryptoObj.getRandomValues(bytes);
  } else {
    throw new Error('Cryptographically secure random number generator (crypto.getRandomValues) is not available.');
  }

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}` as `${string}-${string}-${string}-${string}-${string}`;
}

interface GlobalCryptoPolyfill {
  crypto?: {
    randomUUID?: () => string;
    getRandomValues?: Crypto['getRandomValues'];
  };
}

if (typeof globalThis !== 'undefined') {
  const g = globalThis as unknown as GlobalCryptoPolyfill;
  if (!g.crypto) {
    g.crypto = {};
  }
  if (typeof g.crypto.randomUUID !== 'function') {
    try {
      Object.defineProperty(g.crypto, 'randomUUID', {
        value: generateFallbackUUID,
        writable: true,
        configurable: true,
      });
    } catch {
      g.crypto.randomUUID = generateFallbackUUID;
    }
  }
}

export {};
